import { Stack, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
const ActionButtons = ({
  labelSubmit = 'valider',
  disabled = false,
  onGoBack,
  onSubmit = () => {},
  loading = false
}) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  return (
    <Stack direction={'row'} sx={{alignSelf: 'flex-end'}} gap={2} mt={2}>
      <Button onClick={() => navigate('/advertisements')} size={'xs'}>{t('auth.admin.edit.cancel')}</Button>
      {Boolean(onGoBack) && (
        <Button color="primary" variant="contained" onClick={onGoBack} size={'xs'}>
          {t('ui_elements.form_previous')}
        </Button>
      )}
      <Button color="primary" variant="contained" onClick={onSubmit} disabled={loading || disabled} size={'xs'}>
        {loading ? t('auth.admin.edit.save.loading') : labelSubmit}
      </Button>
    </Stack>
  )
}
export default ActionButtons
